import React, { FC, useState } from 'react';
import { AthleteAttendanceTeam } from '../../models/attendance.models';
import { StatsResponse } from '../../models/stats.models';
import PeriodAccordion from './period-accordion.component';
import './period-summary.component.css';

interface PeriodSummaryProps {
  stats: StatsResponse | null;
  loading: boolean;
  attendanceTeams: AthleteAttendanceTeam[] | null;
  attendanceLoading: boolean;
  onNavigateToTrainingLog?: (period: number, week: number) => void;
}

const PeriodSummary: FC<PeriodSummaryProps> = ({
  stats,
  loading,
  attendanceTeams,
  attendanceLoading,
  onNavigateToTrainingLog,
}) => {
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);

  const periods = stats?.periodBreakdown ?? [];
  const weeks = stats?.weekBreakdown ?? [];

  const handleToggle = (index: number) => {
    setExpandedIndex((prev) => (prev === index ? null : index));
  };

  if (loading) {
    return (
      <div className="period-summary-card">
        <div className="period-summary-header">
          <div className="period-summary-title">Period Summary</div>
          <div className="period-summary-subtitle">Click any period to expand full breakdown</div>
        </div>
        <div className="period-summary-loading">
          {[0, 1, 2, 3].map((i) => (
            <div className="period-summary-skeleton" key={i} />
          ))}
        </div>
      </div>
    );
  }

  if (periods.length === 0) {
    return (
      <div className="period-summary-card">
        <div className="period-summary-header">
          <div className="period-summary-title">Period Summary</div>
          <div className="period-summary-subtitle">Click any period to expand full breakdown</div>
        </div>
        <div className="pa-empty-state">
          <div className="pa-empty-title">No period data available</div>
        </div>
      </div>
    );
  }

  return (
    <div className="period-summary-card">
      <div className="period-summary-header">
        <div className="period-summary-title">Period Summary</div>
        <div className="period-summary-subtitle">Click any period to expand full breakdown</div>
      </div>
      <div className="period-list">
        {periods.map((period, idx) => (
          <PeriodAccordion
            key={period.index}
            period={period}
            previousPeriod={idx > 0 ? periods[idx - 1] : null}
            weeks={weeks}
            expanded={expandedIndex === period.index}
            onToggle={() => handleToggle(period.index)}
            attendanceTeams={attendanceTeams}
            attendanceLoading={attendanceLoading}
            onNavigateToTrainingLog={onNavigateToTrainingLog}
          />
        ))}
      </div>
    </div>
  );
};

export default PeriodSummary;
